export default __webpack_public_path__ + "static/Corprate_WhoWeAre_IF_header_03-c16a832377111eacb591210c333dbb15.jpg";